import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ListingRendererType} from 'nav/expanded/ListingRendererConstants';

import ProcedureMethodTaskListingRenderer from '../procedures/ProcedureMethodTaskListingRenderer';

export default class AssayUnitOperationTaskListingRenderer extends ProcedureMethodTaskListingRenderer<ListingRendererType.ASSAY_UNIT_OPERATION_TASK> {
  listingRendererType = ListingRendererType.ASSAY_UNIT_OPERATION_TASK;

  constructor() {
    super(ProcessClientOrigin.ASSAYS);
  }
}
